export const INSTAGRAM_DOMAIN = '.instagram.com'

export const COOKIE_ORDER: string[] = [
  'sessionid', 'ds_user_id', 'rur', 'mid', 'csrftoken',
  'datr', 'ig_did', 'ig_nrcb', 'wd', 'dpr', 'ps_l', 'ps_n',
]

export type CookieObject = {
  domain?: string
  name?: string
  value?: string
}

export function filterInstagramCookies(
  cookieObjects: CookieObject[],
): Record<string, string> {
  const result: Record<string, string> = {}
  for (const c of cookieObjects) {
    const domain = c.domain ?? ''
    const name = c.name ?? ''
    const value = c.value ?? ''
    if (domain.includes(INSTAGRAM_DOMAIN) && name && value) {
      result[name] = value
    }
  }
  return result
}

export function parseInlineCookies(cookieString: string): Record<string, string> {
  const result: Record<string, string> = {}
  for (const raw of cookieString.split(';')) {
    const item = raw.trim()
    const eq = item.indexOf('=')
    if (eq <= 0) continue
    const key = item.slice(0, eq).trim()
    const value = item.slice(eq + 1).trim()
    if (key) result[key] = value
  }
  return result
}

function normalizeRur(value: string): string {
  let v = value
  while (v.startsWith('"') || v.startsWith("'")) v = v.slice(1)
  while (v.endsWith('"') || v.endsWith("'")) v = v.slice(0, -1)
  return v
}

function formatSingleCookie(name: string, value: string): string {
  if (name === 'rur') {
    const v = normalizeRur(value)
    return v.includes(';') ? `rur="${v}"` : `rur=${v}`
  }
  return `${name}=${value}`
}

export function formatCookieString(
  cookies: Record<string, string>,
  order?: string[],
  trailingSemicolon = false,
): string {
  const ord = order ?? COOKIE_ORDER
  const parts: string[] = []
  const used = new Set<string>()

  for (const name of ord) {
    if (name in cookies) {
      parts.push(formatSingleCookie(name, cookies[name]))
      used.add(name)
    }
  }
  for (const [name, value] of Object.entries(cookies)) {
    if (!used.has(name)) parts.push(formatSingleCookie(name, value))
  }

  let result = parts.join(';')
  if (trailingSemicolon && result) result += ';'
  return result
}

export function fixJsonFormat(jsonString: string): string {
  return jsonString
    .replaceAll('"; "', '": "')
    .replaceAll('"; [', '": [')
    .replaceAll('"; ', '": ')
}

export function decodeBearerToken(bearer: string): Record<string, unknown> {
  const parts = bearer.split(':')
  if (parts.length < 3) return {}
  let encoded = parts[2]
  const missing = encoded.length % 4
  if (missing) encoded += '='.repeat(4 - missing)
  const decoded = atob(encoded)
  return JSON.parse(decoded) as Record<string, unknown>
}

export function encodeBearerToken(sessionid: string, dsUserId: string): string {
  const payload = {
    ds_user_id: String(dsUserId),
    sessionid,
    should_use_header_over_cookies: true,
  }
  const json = JSON.stringify(payload)
  const b64 = btoa(json)
  return `IGT:2:${b64}`
}
